module.exports = "/shiftTasks/components/taskTemplates/templatesList/taskTemplateListItemOptions-c99027.html";